import { render, staticRenderFns } from "./playlists-grid-block.vue?vue&type=template&id=d72ff1d8&scoped=true"
import script from "./playlists-grid-block.vue?vue&type=script&setup=true&lang=js"
export * from "./playlists-grid-block.vue?vue&type=script&setup=true&lang=js"
import style0 from "./playlists-grid-block.vue?vue&type=style&index=0&id=d72ff1d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d72ff1d8",
  null
  
)

export default component.exports